'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commandHandlers;

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ChatActions = require('conversations-core/actions/ChatActions');

var _PubNubPresenceActions = require('conversations-core/actions/PubNubPresenceActions');

var _VisitorBlockActions = require('conversations-core/actions/VisitorBlockActions');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var commandHandlers = (_commandHandlers = {}, _defineProperty(_commandHandlers, _PubNubMessageTypes.CLOSE_CHANNEL, function (message, dispatch) {
  dispatch((0, _ConversationsActions.endConversation)(message.channel));
}), _defineProperty(_commandHandlers, _PubNubMessageTypes.OPEN_CHANNEL, function (message, dispatch) {
  dispatch((0, _ChatActions.switchToChannel)(message.message.data));
}), _defineProperty(_commandHandlers, _PubNubMessageTypes.BLOCK, function (message, dispatch, getState) {
  var isAdmin = (0, _clientSelectors.getIsAdmin)(getState());

  if (!isAdmin) {
    dispatch((0, _PubNubPresenceActions.leaveChannels)());
  } else {
    dispatch((0, _VisitorBlockActions.receivedVisitorBlocked)(message.subscribedChannel));
  }
}), _commandHandlers);

exports.default = _defineProperty({}, _ActionTypes2.default.RECEIVED_COMMAND_MESSAGE, function (action, getState, dispatch, client) {
  var message = action.payload.message;
  var command = message.message.type;


  var functionToExecute = commandHandlers[command];

  if (functionToExecute) {
    functionToExecute(message, dispatch, getState, client);
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/commandMessageHandlers.js
// module id = 495
// module chunks = 0